import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RecentItem {
  id: string;
  type: 'company' | 'contact' | 'bucket' | 'order';
  title: string;
  url: string;
  visitedAt: number;
}

interface RecentState {
  items: RecentItem[];
  addItem: (item: Omit<RecentItem, 'visitedAt'>) => void;
  clear: () => void;
}

const MAX_RECENT = 10;

export const useRecentStore = create<RecentState>()(
  persist(
    (set) => ({
      items: [],

      addItem: (item) =>
        set((state) => {
          const filtered = state.items.filter((i) => i.id !== item.id || i.type !== item.type);
          const next: RecentItem = { ...item, visitedAt: Date.now() };
          return { items: [next, ...filtered].slice(0, MAX_RECENT) };
        }),

      clear: () => set({ items: [] }),
    }),
    {
      name: 'mayksel-recent',
    },
  ),
);
